import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=50f0d0c1&"
import script from "./messageInfo.vue?vue&type=script&lang=js&"
export * from "./messageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f0d0c1')) {
      api.createRecord('50f0d0c1', component.options)
    } else {
      api.reload('50f0d0c1', component.options)
    }
    module.hot.accept("./messageInfo.vue?vue&type=template&id=50f0d0c1&", function () {
      api.rerender('50f0d0c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/messageInfo.vue"
export default component.exports